import { API_BASE_URL } from "../../../configurations/configurations";
import { mainApiSlice } from "../api/mainApiSlice";

export const authApi = mainApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    authDevice: builder.query({
      query: () => ({
        url: "/oauth/device",
        method: "GET",
      }),
    }),
    verifyToken: builder.query({
      query: (token) => ({
        url: `/oauth/verify?token=${token}`,
        method: "GET",
      }),
      providesTags: ["User"],
    }),
    loginUser: builder.mutation({
      query: ({ user_id, userData }) => ({
        url: `/oauth/login`,
        method: "POST",
        body: userData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }),
      providesTags: ["User"],
    }),
    logoutUser: builder.mutation({
      query: (token) => ({
        url: `/oauth/logout?token=${token}`,
        method: "POST",
      }),
    }),
    registerUserRequest: builder.mutation({
      query: (userRegistrationData) => ({
        url: "/oauth/signup-user",
        method: "POST",
        body: userRegistrationData,
      }),
    }),
    changePassword: builder.mutation({
      query: ({ token, changePasswordData }) => ({
        url: `/oauth/change-password?token=${token}`,
        method: "POST",
        body: changePasswordData,
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const {
  useAuthDeviceQuery,
  useVerifyTokenQuery,
  useLoginUserMutation,
  useLogoutUserMutation,
  useRegisterUserRequestMutation,
  useChangePasswordMutation,
} = authApi;
